import { ToggleButton } from "@opensea/ui-kit"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslations } from "use-intl"
import type { ListingFlowFormValues } from "../../types"

export const AdjustForFeesSwitch = () => {
  const t = useTranslations("wallet.AdjustForFeesSwitch")
  const { control } = useFormContext<ListingFlowFormValues>()

  return (
    <Controller
      control={control}
      name="adjustForFees"
      render={({ field }) => {
        const adjustForFees = field.value
        return (
          <ToggleButton
            checked={adjustForFees}
            className={adjustForFees ? "bg-bg-additional-1" : ""}
            onClick={() => field.onChange(!adjustForFees)}
            size="sm"
          >
            {t("adjustForFees")}
          </ToggleButton>
        )
      }}
    />
  )
}
